"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var JackpotsList_1 = require("./component/JackpotsList");
var JackpotEditor_1 = require("./component/JackpotEditor");
var JackpotOperationsConfig_1 = require("./component/JackpotOperationsConfig");
var PJackpotsList = /** @class */ (function (_super) {
    __extends(PJackpotsList, _super);
    function PJackpotsList(props) {
        return _super.call(this, props) || this;
    }
    PJackpotsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrandsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AC = this.props.listAppCurrencyAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_app_currency: data.data });
        });
        this.SID_AL = this.props.listAvailAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ avail_languages: data.data });
        });
        this.SID_AJTT = this.props.listAvailJackpotTransferTypes.Subscribe("*", function (id, data) {
            _this.setState({ avail_jackpot_transfer_types: data.data });
        });
        this.SID_AT = this.props.listAppUserPlayerTagsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_tags: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_app_currency: [],
            avail_jackpot_transfer_types: [],
            avail_tags: []
        }, function () {
            _this.props.listBrandsAvail.LoadData();
            _this.props.listAppCurrencyAvail.LoadData();
            _this.props.listAvailAppLanguages.LoadData();
            _this.props.listAvailJackpotTransferTypes.LoadData();
            _this.props.listAppUserPlayerTagsAvail.LoadData();
        });
    };
    PJackpotsList.prototype.componentWillUnmount = function () {
        this.props.listBrandsAvail.UnSubscribe(this.SID_AB);
        this.props.listAppCurrencyAvail.UnSubscribe(this.SID_AC);
        this.props.listAvailAppLanguages.UnSubscribe(this.SID_AL);
        this.props.listAvailJackpotTransferTypes.UnSubscribe(this.SID_AJTT);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.listAppUserPlayerTagsAvail.UnSubscribe(this.SID_AT);
    };
    PJackpotsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PJackpotsList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", rootRecord: val });
    };
    PJackpotsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PJackpotsList.prototype.onConfigClick = function (val) {
        this.setState({ edit_mode: "CONFIG", rootRecord: val });
    };
    /* private onGoBackTranslateClick() {
         this.setState({ edit_mode: "LOCALES-LIST", localeRecord: null });
     }
 
     private onTranslateListClick(val: IJackpotItem) {
         this.setState({ edit_mode: "LOCALES-LIST", rootRecord: val });
     }
 
     private onNewTagClick() {
         this.setState({ edit_mode: "TAG-NEW" });
     }
 
     private onPlayerTagsListClick(val: IJackpotItem) {
         this.setState({ edit_mode: "TAGS-LIST", rootRecord: val });
     }
 
     private onWinHistoryListClick(val: IJackpotItem) {
         this.setState({ edit_mode: "WIN-HISTORY", rootRecord: val });
     }
 
     private onTransferHistoryListClick(val: IJackpotItem) {
         this.setState({ edit_mode: "TRANSFER-HISTORY", rootRecord: val });
     }
 
     private onTransferActionClick(val: IJackpotItem) {
         this.setState({ edit_mode: "TRANSFER-ACTION", rootRecord: val });
     }
 
     private onNewTranslateClick() {
         this.setState({ edit_mode: "LOCALE-NEW", localeRecord: null });
     }
 
     private onEditTranslateClick(val: IJackpotLocalesListItem) {
         this.setState({ edit_mode: "LOCALE-EDIT", localeRecord: val });
     }*/
    PJackpotsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PJackpotsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PJackpotsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(JackpotEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), appCurrencyAvail: this.state.avail_app_currency, brandsAvail: this.state.avail_brands, listBonusPermissionTypes: this.props.listBonusPermissionTypes }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(JackpotEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this), appCurrencyAvail: this.state.avail_app_currency, brandsAvail: this.state.avail_brands, listBonusPermissionTypes: this.props.listBonusPermissionTypes }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(JackpotsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), 
                // onTranslateClick={this.onTranslateListClick.bind(this)}
                //  onPlayerTagsClick={this.onPlayerTagsListClick.bind(this)}
                onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, brandsList: this.state.brands_list, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), financeManualDlg: this.props.financeManualDlg, 
                //onJackpotWinnersHistoryClick={this.onWinHistoryListClick.bind(this)}
                //onJackpotTransferHistoryClick={this.onTransferHistoryListClick.bind(this)}
                onConfigClick: this.onConfigClick.bind(this) }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(JackpotOperationsConfig_1.default, { state: this.props.state, dataJackpotLocales: this.props.dataLocales, dataJackpotRestrictedPlayerTags: this.props.dataTags, dataJackpotWinHistory: this.props.dataHistory, dataJackpotTransferHistory: this.props.dataTransfers, rootRecord: this.state.rootRecord, availLanguages: this.state.avail_languages, availPlayerTags: this.state.avail_tags, availTransferTypes: this.state.avail_jackpot_transfer_types, onGoBackClick: this.onGoBackClick.bind(this), dlgSelectPlayer: this.props.dlgSelectPlayer, dataPlayersAvail: this.props.dataPlayersAvail }));
        }
        /* if (this.state.edit_mode === "LOCALES-LIST") {
             return (
                 <JackpotLocalesList
                     data={this.props.dataLocales}
                     state={this.props.state}
                     onGoBack={this.onGoBackClick.bind(this)}
                     rootRecord={this.state.rootRecord}
                     onNewClick={this.onNewTranslateClick.bind(this)}
                     onEditClick={this.onEditTranslateClick.bind(this)}
                 />
             )
         }
         if (this.state.edit_mode === "LOCALE-NEW") {
             return (
                 <JackpotLocaleEditor
                     data={this.props.dataLocales}
                     state={this.props.state}
                     onGoBack={this.onGoBackTranslateClick.bind(this)}
                     rootRecord={this.state.rootRecord}
                     record={this.state.localeRecord}
                     availLanguages={this.state.avail_languages}
                 />
             )
         }
         if (this.state.edit_mode === "LOCALE-EDIT") {
             return (
                 <JackpotLocaleEditor
                     data={this.props.dataLocales}
                     state={this.props.state}
                     onGoBack={this.onGoBackTranslateClick.bind(this)}
                     rootRecord={this.state.rootRecord}
                     record={this.state.localeRecord}
                     availLanguages={this.state.avail_languages}
                 />
             )
         }
         if (this.state.edit_mode === "TAGS-LIST") {
             return (
                 <JackpotPlayerTagsList
                     data={this.props.dataTags}
                     state={this.props.state}
                     onGoBack={this.onGoBackClick.bind(this)}
                     rootRecord={this.state.rootRecord}
                     // dataTags={this.props.listAppUserPlayerTagsAvail}
                     onNewClick={this.onNewTagClick.bind(this)}
                 />
             )
         }
         if (this.state.edit_mode === "TAG-NEW") {
             return (
                 <JackpotPlayerTagEditor
                     data={this.props.dataTags}
                     state={this.props.state}
                     onGoBack={this.onGoBackClick.bind(this)}
                     rootRecord={this.state.rootRecord}
                     availPlayerTags={this.state.avail_tags}
                     // dataTags={this.props.listAppUserPlayerTagsAvail}
                    // onNewClick={() => { }}
                 />
             )
         }
         if (this.state.edit_mode === "WIN-HISTORY") {
             return (
                 <JackpotWinHistoryList
                     data={this.props.dataHistory}
                     state={this.props.state}
                     onGoBackClick={this.onGoBackClick.bind(this)}
                     record={this.state.rootRecord}
                 />
             )
         }
         if (this.state.edit_mode === "TRANSFER-HISTORY") {
             return (
                 <JackpotTransferHistoryList
                     data={this.props.dataTransfers}
                     state={this.props.state}
                     onGoBackClick={this.onGoBackClick.bind(this)}
                     onCreateClick={this.onTransferActionClick.bind(this)}
                     record={this.state.rootRecord}
                 />
             )
         }
         if (this.state.edit_mode === "TRANSFER-ACTION") {
             return (
                 <JackpotTransferEditor
                     data={this.props.dataTransfers}
                     state={this.props.state}
                     onGoBack={this.onTransferHistoryListClick.bind(this)}
                     record={this.state.rootRecord}
                     availTransferTypes={this.state.avail_jackpot_transfer_types}
                 />
             )
         }*/
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PJackpotsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PJackpotsList.getPageDescription = function (state) {
        return {
            icon: "crown",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_jackpots + "-id",
            itemTitle: "Джекпоты",
            route: routes_1.routes.page_gift_jackpots,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PJackpotsList;
}(React.Component));
exports.default = PJackpotsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/PJackpotsList.tsx
// module id = 2339
// module chunks = 0